/* ============================================================
   VEDIC RECOMMENDER — ENGINE & UI
   ============================================================
   IIFE-wrapped to avoid leaking globals into the theme.
   Reads product catalogue from the inline JSON script tag.
   ============================================================ */

(function () {
  'use strict';

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var section = document.querySelector('.vedic-rec');
    if (!section) return;

    var dbScript = section.querySelector('#vr-stone-db');
    if (!dbScript) {
      console.warn('[Vedic Recommender] Stone DB JSON not found');
      return;
    }

    var STONE_DB;
    try {
      STONE_DB = JSON.parse(dbScript.textContent);
    } catch (e) {
      console.error('[Vedic Recommender] Failed to parse stone DB:', e);
      return;
    }

    // ============================================================
    // VEDIC LOGIC
    // ============================================================

    var SIGNS = ["Aries","Taurus","Gemini","Cancer","Leo","Virgo","Libra","Scorpio","Sagittarius","Capricorn","Aquarius","Pisces"];
    var PLANETS = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn","Rahu","Ketu"];

    var SIGN_LORDS = {
      Aries:"Mars", Taurus:"Venus", Gemini:"Mercury", Cancer:"Moon",
      Leo:"Sun", Virgo:"Mercury", Libra:"Venus", Scorpio:"Mars",
      Sagittarius:"Jupiter", Capricorn:"Saturn", Aquarius:"Saturn", Pisces:"Jupiter"
    };

    var DEBILITATED = { Sun:"Libra", Moon:"Scorpio", Mars:"Cancer", Mercury:"Pisces", Jupiter:"Capricorn", Venus:"Virgo", Saturn:"Aries", Rahu:"Sagittarius", Ketu:"Gemini" };
    var EXALTED     = { Sun:"Aries", Moon:"Taurus", Mars:"Capricorn", Mercury:"Virgo", Jupiter:"Cancer", Venus:"Pisces", Saturn:"Libra", Rahu:"Gemini", Ketu:"Sagittarius" };
    var OWN_SIGNS   = { Sun:["Leo"], Moon:["Cancer"], Mars:["Aries","Scorpio"], Mercury:["Gemini","Virgo"], Jupiter:["Sagittarius","Pisces"], Venus:["Taurus","Libra"], Saturn:["Capricorn","Aquarius"], Rahu:[], Ketu:[] };
    var FRIENDS = {
      Sun:["Moon","Mars","Jupiter"], Moon:["Sun","Mercury"], Mars:["Sun","Moon","Jupiter"],
      Mercury:["Sun","Venus"], Jupiter:["Sun","Moon","Mars"], Venus:["Mercury","Saturn"],
      Saturn:["Mercury","Venus"], Rahu:["Venus","Saturn"], Ketu:["Mars","Venus"]
    };

    var KENDRA = [1,4,7,10];
    var TRIKONA = [1,5,9];
    var DUSHTANA = [6,8,12];
    var DASHA_ORDER = ["Ketu","Venus","Sun","Moon","Mars","Rahu","Jupiter","Saturn","Mercury"];
    var DASHA_YEARS = { Ketu:7, Venus:20, Sun:6, Moon:10, Mars:7, Rahu:18, Jupiter:16, Saturn:19, Mercury:17 };
    var NATURAL_MALEFIC = ["Sun","Mars","Saturn","Rahu","Ketu"];

    // ============================================================
    // NAKSHATRAS — 27 lunar mansions in classical Vedic order.
    // Each spans 13°20' of the zodiac. The Moon's nakshatra at birth
    // is one of the most important data points in the patri.
    // ============================================================
    var NAKSHATRAS = [
      { name: "Ashwini",          lord: "Ketu",    devata: "Ashwini Kumaras" },
      { name: "Bharani",          lord: "Venus",   devata: "Yama" },
      { name: "Krittika",         lord: "Sun",     devata: "Agni" },
      { name: "Rohini",           lord: "Moon",    devata: "Brahma" },
      { name: "Mrigashira",       lord: "Mars",    devata: "Soma" },
      { name: "Ardra",            lord: "Rahu",    devata: "Rudra" },
      { name: "Punarvasu",        lord: "Jupiter", devata: "Aditi" },
      { name: "Pushya",           lord: "Saturn",  devata: "Brihaspati" },
      { name: "Ashlesha",         lord: "Mercury", devata: "Nagas" },
      { name: "Magha",            lord: "Ketu",    devata: "Pitrs" },
      { name: "Purva Phalguni",   lord: "Venus",   devata: "Bhaga" },
      { name: "Uttara Phalguni",  lord: "Sun",     devata: "Aryaman" },
      { name: "Hasta",            lord: "Moon",    devata: "Savitar" },
      { name: "Chitra",           lord: "Mars",    devata: "Vishvakarma" },
      { name: "Swati",            lord: "Rahu",    devata: "Vayu" },
      { name: "Vishakha",         lord: "Jupiter", devata: "Indra-Agni" },
      { name: "Anuradha",         lord: "Saturn",  devata: "Mitra" },
      { name: "Jyeshtha",         lord: "Mercury", devata: "Indra" },
      { name: "Mula",             lord: "Ketu",    devata: "Nirriti" },
      { name: "Purva Ashadha",    lord: "Venus",   devata: "Apas" },
      { name: "Uttara Ashadha",   lord: "Sun",     devata: "Vishvedevas" },
      { name: "Shravana",         lord: "Moon",    devata: "Vishnu" },
      { name: "Dhanishta",        lord: "Mars",    devata: "Vasus" },
      { name: "Shatabhisha",      lord: "Rahu",    devata: "Varuna" },
      { name: "Purva Bhadrapada", lord: "Jupiter", devata: "Aja Ekapada" },
      { name: "Uttara Bhadrapada",lord: "Saturn",  devata: "Ahir Budhnya" },
      { name: "Revati",           lord: "Mercury", devata: "Pushan" }
    ];

    // ============================================================
    // HOUSE MEANINGS — what each of the 12 houses governs in classical
    // Vedic astrology. Used in the planet-positions table.
    // ============================================================
    var HOUSE_MEANINGS = [
      "Self, body, character",            // 1 — Lagna / Tanu Bhava
      "Wealth, family, speech",           // 2 — Dhana Bhava
      "Siblings, courage, effort",        // 3 — Sahaja Bhava
      "Mother, home, comforts",           // 4 — Sukha Bhava
      "Children, wisdom, devotion",       // 5 — Putra Bhava
      "Enemies, debts, illness",          // 6 — Ari Bhava
      "Marriage, partnerships",           // 7 — Yuvati Bhava
      "Longevity, transformation",        // 8 — Ayur Bhava
      "Father, dharma, fortune",          // 9 — Bhagya Bhava
      "Career, status, action",           // 10 — Karma Bhava
      "Gains, friends, fulfilment",       // 11 — Labha Bhava
      "Loss, expenses, moksha"            // 12 — Vyaya Bhava
    ];

    // ============================================================
    // PLANET REMEDIES — short, traditional remedies for each graha
    // when it is the dominant affliction. Used in the patri's
    // recommendations section.
    // ============================================================
    var REMEDIES = {
      Sun:    ["Offer water to the rising sun every Sunday morning","Recite Aditya Hridaya Stotra","Donate wheat or jaggery on Sundays","Wear copper or ruby (under astrologer's guidance)"],
      Moon:   ["Drink water from a silver vessel","Fast on Mondays or offer milk to Shiva","Donate rice, milk, or white cloth","Wear pearl or moonstone"],
      Mars:   ["Recite Hanuman Chalisa daily","Offer red flowers to Hanuman on Tuesdays","Donate red lentils (masoor dal)","Wear red coral (under astrologer's guidance)"],
      Mercury: ["Chant Vishnu Sahasranama on Wednesdays","Donate green moong dal","Feed green vegetables to a cow","Wear emerald or green tourmaline"],
      Jupiter: ["Recite Guru Stotra or Vishnu Sahasranama on Thursdays","Donate yellow items — turmeric, chana dal, gold","Respect teachers and elders","Wear yellow sapphire (under astrologer's guidance)"],
      Venus:   ["Offer white flowers to Lakshmi on Fridays","Donate white items — milk, rice, white clothes","Maintain harmony in relationships","Wear diamond or white sapphire"],
      Saturn:  ["Light a mustard-oil lamp under a peepal tree on Saturdays","Donate black sesame, iron, or shoes to the needy","Serve the poor and elderly","Wear blue sapphire (only after testing under astrologer's guidance)"],
      Rahu:    ["Recite Rahu mantra: Om Bhram Bhreem Bhroum Sah Rahave Namah","Donate black or grey items on Saturdays","Avoid alcohol, tobacco, and shortcuts","Wear hessonite (gomedh)"],
      Ketu:    ["Recite Ketu mantra: Om Sram Sreem Shroum Sah Ketave Namah","Donate blankets or sesame on Tuesdays","Spend time in spiritual practice","Wear cat's eye (chrysoberyl)"]
    };

    // ============================================================
    // NAMAKSHARA — the nakshatra of the first letter of the name.
    // Each of the 27 classical nakshatras is ruled by one of the 9
    // grahas (in the Vimshottari sequence repeating 3 times).
    //
    // Below: the standard mapping of first letters/syllables to
    // nakshatras → the ruling graha. Based on classical Vedic
    // gemology texts. Both Latin transliteration and Devanagari
    // letters are supported.
    // ============================================================
    var NAMAKSHARA = {
      // Ashwini (Ketu): Chu Che Cho La
      'chu': 'Ketu', 'che': 'Ketu', 'cho': 'Ketu', 'la': 'Ketu',
      // Bharani (Venus): Li Lu Le Lo
      'li': 'Venus', 'lu': 'Venus', 'le': 'Venus', 'lo': 'Venus',
      // Krittika (Sun): A I U E (single vowel) + Ee, Ai, Au
      'a': 'Sun', 'i': 'Sun', 'u': 'Sun', 'e': 'Sun', 'ai': 'Sun', 'au': 'Sun',
      // Rohini (Moon): O Va Vi Vu
      'o': 'Moon', 'va': 'Moon', 'vi': 'Moon', 'vu': 'Moon', 'wa': 'Moon', 'wi': 'Moon',
      // Mrigashira (Mars): Ve Vo Ka Ki
      've': 'Mars', 'vo': 'Mars', 'ka': 'Mars', 'ki': 'Mars', 'we': 'Mars',
      // Ardra (Rahu): Ku Gha Ng Chh
      'ku': 'Rahu', 'gh': 'Rahu', 'ng': 'Rahu', 'chh': 'Rahu',
      // Punarvasu (Jupiter): Ke Ko Ha Hi
      'ke': 'Jupiter', 'ko': 'Jupiter', 'ha': 'Jupiter', 'hi': 'Jupiter',
      // Pushya (Saturn): Hu He Ho Da
      'hu': 'Saturn', 'he': 'Saturn', 'ho': 'Saturn', 'da': 'Saturn',
      // Ashlesha (Mercury): Di Du De Do
      'di': 'Mercury', 'du': 'Mercury', 'de': 'Mercury', 'do': 'Mercury',
      // Magha (Ketu): Ma Mi Mu Me
      'ma': 'Ketu', 'mi': 'Ketu', 'mu': 'Ketu', 'me': 'Ketu',
      // Purva Phalguni (Venus): Mo Ta Ti Tu
      'mo': 'Venus', 'ta': 'Venus', 'ti': 'Venus', 'tu': 'Venus',
      // Uttara Phalguni (Sun): Te To Pa Pi
      'te': 'Sun', 'to': 'Sun', 'pa': 'Sun', 'pi': 'Sun',
      // Hasta (Moon): Pu Sha Na Tha
      'pu': 'Moon', 'sha': 'Moon', 'na': 'Moon', 'tha': 'Moon',
      // Chitra (Mars): Pe Po Ra Ri
      'pe': 'Mars', 'po': 'Mars', 'ra': 'Mars', 'ri': 'Mars',
      // Swati (Rahu): Ru Re Ro Tha
      'ru': 'Rahu', 're': 'Rahu', 'ro': 'Rahu',
      // Vishakha (Jupiter): Ti Tu Te To (alt) -- using Ji Bhu
      'ji': 'Jupiter', 'bha': 'Jupiter', 'bhu': 'Jupiter', 'gu': 'Jupiter',
      // Anuradha (Saturn): Na Ne Nu Ni
      'ne': 'Saturn', 'no': 'Saturn', 'ni': 'Saturn', 'nu': 'Saturn',
      // Jyeshtha (Mercury): Ye Yo Bha Bhi
      'ye': 'Mercury', 'yo': 'Mercury', 'bhi': 'Mercury', 'bhe': 'Mercury',
      // Mula (Ketu): Ye Yo Bha Bhi (alt: Yo Bha Bhi Bhu)
      'ya': 'Ketu', 'yu': 'Ketu',
      // Purva Ashadha (Venus): Bu Dha Pha Bha
      'bu': 'Venus', 'dha': 'Venus', 'pha': 'Venus',
      // Uttara Ashadha (Sun): Be Bo Ja Ji
      'be': 'Sun', 'bo': 'Sun', 'ja': 'Sun',
      // Shravana (Moon): Khi Khu Khe Kho
      'khi': 'Moon', 'khu': 'Moon', 'khe': 'Moon', 'kho': 'Moon',
      // Dhanishta (Mars): Ga Gi Gu Ge
      'ga': 'Mars', 'gi': 'Mars', 'ge': 'Mars',
      // Shatabhisha (Rahu): Go Sa Si Su
      'go': 'Rahu', 'sa': 'Rahu', 'si': 'Rahu', 'su': 'Rahu',
      // Purva Bhadrapada (Jupiter): Se So Da Di
      'se': 'Jupiter', 'so': 'Jupiter',
      // Uttara Bhadrapada (Saturn): Du Tha Jha Da
      'jha': 'Saturn',
      // Revati (Mercury): De Do Cha Chi
      'cha': 'Mercury', 'chi': 'Mercury'
    };

    function getNamaksharaGraha(name) {
      if (!name || typeof name !== 'string') return null;
      // Lowercase, strip leading/trailing whitespace and any non-letter chars at start
      var clean = name.toLowerCase().trim();

      // Strip honorifics (with or without trailing dot/space)
      var honorificPatterns = [
        /^mr\.?\s+/, /^ms\.?\s+/, /^mrs\.?\s+/, /^dr\.?\s+/,
        /^pt\.?\s+/, /^pandit\s+/, /^sri\s+/, /^shri\s+/,
        /^smt\.?\s+/, /^miss\s+/, /^master\s+/
      ];
      honorificPatterns.forEach(function (re) {
        clean = clean.replace(re, '');
      });
      clean = clean.trim();
      if (clean.length === 0) return null;

      // Get first word only (some entries are full names)
      var firstWord = clean.split(/\s+/)[0];
      // Strip any non-letter prefix
      firstWord = firstWord.replace(/^[^a-z]+/, '');
      if (firstWord.length === 0) return null;

      // Try progressively shorter prefixes: 3-char, 2-char, 1-char
      var tries = [
        firstWord.slice(0, 3),
        firstWord.slice(0, 2),
        firstWord.slice(0, 1)
      ];
      for (var t = 0; t < tries.length; t++) {
        if (NAMAKSHARA[tries[t]]) return NAMAKSHARA[tries[t]];
      }

      // Fallback: scan for first consonant + first vowel pattern
      // (handles names like "Priya", "Sneha", "Krishna" where the first
      // 2-3 chars are unmapped consonant clusters)
      var firstVowelIdx = firstWord.search(/[aeiou]/);
      if (firstVowelIdx > 0) {
        // Take last consonant before vowel + the vowel
        var consonantVowel = firstWord.charAt(firstVowelIdx - 1) + firstWord.charAt(firstVowelIdx);
        if (NAMAKSHARA[consonantVowel]) return NAMAKSHARA[consonantVowel];
      }

      // Last resort: first vowel by itself
      if (firstVowelIdx >= 0) {
        var vowel = firstWord.charAt(firstVowelIdx);
        if (NAMAKSHARA[vowel]) return NAMAKSHARA[vowel];
      }

      return null;
    }

    function generateBirthChart(dob, tob, pob) {
      var seedStr = (dob + tob + (pob || "")).toLowerCase();
      var seed = 0;
      for (var i = 0; i < seedStr.length; i++) {
        seed = ((seed * 31) + seedStr.charCodeAt(i)) | 0;
      }
      seed = Math.abs(seed) + 1;

      var PRIMES = [17,31,53,71,89,103,127,149,167,193,223,239,263,283,317,349,379,409,439,463];
      var rng = function (n) {
        var p = PRIMES[n % PRIMES.length];
        var x = Math.sin(seed * p + p * p) * 100000;
        return ((Math.floor(Math.abs(x)) % 12) + 12) % 12;
      };
      var rngN = function (n, max) {
        var p = PRIMES[(n + 7) % PRIMES.length];
        var x = Math.sin(seed * p * 1.7 + p) * 100000;
        return ((Math.floor(Math.abs(x)) % max) + max) % max;
      };

      var ascSignIdx = rng(1);
      var ascendant = SIGNS[ascSignIdx];
      var sunSignIdx = rng(2);
      var sunDegree = rngN(3, 30);

      var chart = { ascendant: ascendant, ascendantIndex: ascSignIdx, planets: {} };

      PLANETS.forEach(function (planet, i) {
        var signIdx = (planet === "Sun") ? sunSignIdx : rng(10 + i * 3);
        var sign = SIGNS[signIdx];
        var house = ((signIdx - ascSignIdx + 12) % 12) + 1;
        var degree = rngN(50 + i * 3, 30);

        var combust = false;
        if (planet !== "Sun" && signIdx === sunSignIdx) {
          if (Math.abs(degree - sunDegree) < 8) combust = true;
        }

        var retroEligible = ["Mercury","Venus","Mars","Jupiter","Saturn"].indexOf(planet) > -1;
        var retrograde = retroEligible && rngN(100 + i * 3, 4) === 0;

        chart.planets[planet] = {
          sign: sign, signIndex: signIdx, house: house, degree: degree,
          debilitated: DEBILITATED[planet] === sign,
          exalted: EXALTED[planet] === sign,
          ownSign: (OWN_SIGNS[planet] || []).indexOf(sign) > -1,
          friendlySign: (FRIENDS[planet] || []).indexOf(SIGN_LORDS[sign]) > -1,
          combust: combust,
          retrograde: retrograde
        };
      });

      chart.lagnaLord = SIGN_LORDS[ascendant];
      chart.rashi = chart.planets.Moon.sign;
      chart.rashiLord = SIGN_LORDS[chart.rashi];

      var rahuHouse = chart.planets.Rahu.house;
      var ketuHouse = chart.planets.Ketu.house;
      PLANETS.forEach(function (planet) {
        if (planet === "Rahu" || planet === "Ketu") return;
        chart.planets[planet].conjunctRahu = chart.planets[planet].house === rahuHouse;
        chart.planets[planet].conjunctKetu = chart.planets[planet].house === ketuHouse;
      });

      var birthYear = parseInt(dob.split('-')[0], 10) || 1995;
      var ageYears = (new Date()).getFullYear() - birthYear;
      var dashaStartIdx = rngN(200, 9);
      var mahadashaLord = DASHA_ORDER[dashaStartIdx];
      var runningYears = ageYears;
      for (var step = 0; step < 9; step++) {
        var lord = DASHA_ORDER[(dashaStartIdx + step) % 9];
        if (runningYears < DASHA_YEARS[lord]) { mahadashaLord = lord; break; }
        runningYears -= DASHA_YEARS[lord];
      }
      chart.mahadashaLord = mahadashaLord;

      // ============================================================
      // NAKSHATRA — derive from Moon's position. Each nakshatra spans
      // 13°20' (= 800 minutes). The Moon's longitude across all 12 signs
      // gives a value 0–360°. We map to a nakshatra index 0–26 and a
      // pada (quarter) 1–4.
      // ============================================================
      var moonLongitude = chart.planets.Moon.signIndex * 30 + chart.planets.Moon.degree;
      var nakIdx = Math.floor(moonLongitude / (360 / 27)) % 27;
      var nakProgress = (moonLongitude / (360 / 27)) - nakIdx;
      var pada = Math.floor(nakProgress * 4) + 1;
      if (pada > 4) pada = 4;
      if (pada < 1) pada = 1;
      chart.nakshatra = NAKSHATRAS[nakIdx].name;
      chart.nakshatraIndex = nakIdx;
      chart.nakshatraLord = NAKSHATRAS[nakIdx].lord;
      chart.nakshatraDevata = NAKSHATRAS[nakIdx].devata;
      chart.nakshatraPada = pada;

      // ============================================================
      // DASHA TIMELINE — current period and next 3 mahadashas with
      // approximate calendar dates. Computed from birth year forward.
      // ============================================================
      // Find the running mahadasha's start year by walking from birth
      var mahadashaStartYear = birthYear;
      var idx = dashaStartIdx;
      var remainingForCurrent = DASHA_YEARS[DASHA_ORDER[idx]];
      var yearsConsumed = 0;
      while (yearsConsumed + DASHA_YEARS[DASHA_ORDER[idx]] <= ageYears) {
        yearsConsumed += DASHA_YEARS[DASHA_ORDER[idx]];
        mahadashaStartYear = birthYear + yearsConsumed;
        idx = (idx + 1) % 9;
      }
      // idx now points to current mahadasha
      var timeline = [];
      var cursor = mahadashaStartYear;
      for (var d = 0; d < 4; d++) {
        var dlord = DASHA_ORDER[(idx + d) % 9];
        var dyears = DASHA_YEARS[dlord];
        timeline.push({
          lord: dlord,
          startYear: cursor,
          endYear: cursor + dyears,
          years: dyears,
          isCurrent: d === 0
        });
        cursor += dyears;
      }
      chart.dashaTimeline = timeline;

      // ============================================================
      // DOSHAS — three classical afflictions checked in every patri.
      // ============================================================
      // Mangal Dosha (Manglik): Mars in 1st, 4th, 7th, 8th, or 12th house
      var marsHouse = chart.planets.Mars.house;
      chart.manglik = [1, 4, 7, 8, 12].indexOf(marsHouse) > -1;

      // Kaal Sarp Dosha: all 7 main planets between Rahu and Ketu (no planet outside that arc)
      // Rahu and Ketu are always 180° apart. We check if all 7 planets lie on one side.
      var rahuH = chart.planets.Rahu.house;
      var ketuH = chart.planets.Ketu.house;
      // Houses from Rahu to Ketu going forward
      var arcHouses = [];
      var h = rahuH;
      while (h !== ketuH) {
        arcHouses.push(h);
        h = (h % 12) + 1;
      }
      var planetsInArc = 0;
      var planetsOutsideArc = 0;
      ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn"].forEach(function (pl) {
        if (arcHouses.indexOf(chart.planets[pl].house) > -1) planetsInArc++;
        else planetsOutsideArc++;
      });
      // If all 7 planets are on one side of the Rahu-Ketu axis, it's Kaal Sarp
      chart.kaalSarp = (planetsInArc === 7 || planetsOutsideArc === 7);

      // Sade Sati: Saturn transiting 12th, 1st, or 2nd from natal Moon.
      // Since we don't have real-time transits, we approximate based on
      // current Saturn position relative to natal Moon sign.
      var moonSignIdx = chart.planets.Moon.signIndex;
      var saturnSignIdx = chart.planets.Saturn.signIndex;
      var diff = (saturnSignIdx - moonSignIdx + 12) % 12;
      // 11 = 12th from Moon, 0 = same as Moon (1st from Moon), 1 = 2nd from Moon
      chart.sadeSati = (diff === 11 || diff === 0 || diff === 1);

      return chart;
    }

    function housesRuledBy(chart, planet) {
      var houses = [];
      for (var h = 1; h <= 12; h++) {
        var signIdx = (chart.ascendantIndex + h - 1) % 12;
        var sign = SIGNS[signIdx];
        if (SIGN_LORDS[sign] === planet) houses.push(h);
      }
      return houses;
    }

    function scoreAfflictions(chart) {
      var scores = {};
      var reasons = {};
      PLANETS.forEach(function (planet) {
        var p = chart.planets[planet];
        var score = 0;
        var why = [];

        if (p.debilitated)               { score += 6; why.push("debilitated in " + p.sign); }
        if (DUSHTANA.indexOf(p.house) > -1) {
          score += 5;
          why.push("placed in the " + p.house + "th house of " + (p.house===6 ? "struggle" : (p.house===8 ? "obstruction" : "loss")));
        }
        if (p.conjunctRahu)              { score += 4; why.push("shadowed by Rahu"); }
        if (p.conjunctKetu)              { score += 4; why.push("darkened by Ketu"); }
        if (p.combust)                   { score += 3; why.push("combust, burned by the Sun"); }
        if (p.retrograde)                { score += 2; why.push("moving in retrograde"); }

        var housesRuled = housesRuledBy(chart, planet);
        var rulesDushtana = housesRuled.some(function (h) { return DUSHTANA.indexOf(h) > -1; });
        var rulesTrikonaH = housesRuled.some(function (h) { return TRIKONA.indexOf(h) > -1 && h !== 1; });
        var rulesKendraH  = housesRuled.some(function (h) { return KENDRA.indexOf(h) > -1 && h !== 1; });
        if (rulesDushtana && !housesRuled.some(function (h) { return TRIKONA.indexOf(h) > -1; })) {
          score += 3;
          why.push("functional malefic — rules a dushtana house");
        }

        if (p.exalted)                   { score -= 4; why.push("exalted in " + p.sign + " — strong"); }
        if (p.ownSign)                   { score -= 3; why.push("in own sign " + p.sign + " — comfortable"); }
        if (p.friendlySign && !p.ownSign){ score -= 2; why.push("in friendly sign"); }
        if (rulesTrikonaH)               { score -= 3; why.push("functional benefic — trikona lord"); }
        if (rulesKendraH && NATURAL_MALEFIC.indexOf(planet) === -1) {
          score -= 2; why.push("kendra lord");
        }

        if (planet === chart.lagnaLord)     score *= 1.3;
        if (planet === chart.mahadashaLord) score *= 1.5;

        scores[planet] = parseFloat(score.toFixed(2));
        reasons[planet] = why;
      });
      return { scores: scores, reasons: reasons };
    }

    function findDominantGraha(scores, chart) {
      var tieBreakOrder = [chart.lagnaLord, chart.mahadashaLord, "Saturn","Rahu","Ketu","Mars","Sun","Jupiter","Mercury","Venus","Moon"];
      var entries = Object.keys(scores).map(function (k) { return [k, scores[k]]; });
      entries.sort(function (a, b) {
        if (b[1] !== a[1]) return b[1] - a[1];
        return tieBreakOrder.indexOf(a[0]) - tieBreakOrder.indexOf(b[0]);
      });
      return entries[0][0];
    }

    function ord(n) {
      if (n === 1) return "st"; if (n === 2) return "nd"; if (n === 3) return "rd";
      if (n === 21) return "st"; if (n === 22) return "nd"; if (n === 23) return "rd";
      return "th";
    }

    function buildChartFinding(chart, dominant, reasons) {
      var p = chart.planets[dominant];
      var why = reasons[dominant] || [];
      var isLagnaLord = dominant === chart.lagnaLord;
      var isDashaLord = dominant === chart.mahadashaLord;
      var parts = [];

      if (why.length > 0) {
        var top = why.slice(0, 2).join(", and ");
        parts.push(dominant + " sits in your " + p.house + ord(p.house) + " house in " + p.sign + ", " + top);
      } else {
        parts.push(dominant + " occupies your " + p.house + ord(p.house) + " house in " + p.sign + ", calling for support");
      }

      if (isLagnaLord && isDashaLord) {
        parts.push("As both your Lagna lord and your current Mahadasha lord, " + dominant + " governs not just your chart but the very phase of life you are walking through now");
      } else if (isLagnaLord) {
        parts.push("As your Lagna lord, " + dominant + " shapes the entire arc of your life — its condition cannot be ignored");
      } else if (isDashaLord) {
        parts.push("You are currently running " + dominant + " Mahadasha — its energy directly governs the next chapter of your life");
      }

      return parts.join(". ") + ".";
    }

    function recommendBracelet(dob, tob, pob, name) {
      var chart = generateBirthChart(dob, tob, pob);
      var s = scoreAfflictions(chart);

      // Namakshara — first letter of the name maps to a graha.
      // If that graha is also afflicted in the chart (positive score),
      // it gets a bonus weight of +2. This is the classical bridging
      // between Janma Nakshatra (chart-based) and Namakshara (name-based).
      var namaksharaGraha = getNamaksharaGraha(name);
      if (namaksharaGraha && s.scores[namaksharaGraha] > 0) {
        s.scores[namaksharaGraha] = parseFloat((s.scores[namaksharaGraha] + 2).toFixed(2));
        if (!s.reasons[namaksharaGraha]) s.reasons[namaksharaGraha] = [];
        s.reasons[namaksharaGraha].unshift('aligned with your Namakshara — the nakshatra of your name');
      }

      var dominant = findDominantGraha(s.scores, chart);
      var graha = STONE_DB[dominant];
      var finding = buildChartFinding(chart, dominant, s.reasons);
      return {
        graha: graha,
        dominant: dominant,
        chart: chart,
        finding: finding,
        name: name || '',
        // Pass through birth details so the patri builder can use them
        dob: dob,
        tob: tob,
        pob: pob || '',
        namaksharaGraha: namaksharaGraha
      };
    }

    /**
     * Score a REAL chart (from the Cloudflare Worker / Prokerala) against
     * the bracelet catalogue. This is the new primary path — it replaces
     * the local-engine recommendBracelet for live readings.
     *
     * The chart object must have the same shape as what generateBirthChart
     * produces: ascendant, ascendantIndex, lagnaLord, mahadashaLord, and
     * a `planets` map with each planet's house, sign, exalted, debilitated,
     * ownSign, combust, retrograde, conjunctRahu, conjunctKetu flags.
     *
     * The worker constructs exactly that shape (see worker.js → buildResponse).
     */
    function recommendBraceletFromChart(chart, name) {
      // Defensive: if the chart is missing critical fields, fall back to
      // a friendlier error rather than crashing in the scoring code.
      if (!chart || !chart.planets || Object.keys(chart.planets).length < 7) {
        throw new Error('Incomplete chart data from API');
      }

      var s = scoreAfflictions(chart);

      var namaksharaGraha = getNamaksharaGraha(name);
      if (namaksharaGraha && s.scores[namaksharaGraha] > 0) {
        s.scores[namaksharaGraha] = parseFloat((s.scores[namaksharaGraha] + 2).toFixed(2));
        if (!s.reasons[namaksharaGraha]) s.reasons[namaksharaGraha] = [];
        s.reasons[namaksharaGraha].unshift('aligned with your Namakshara \u2014 the nakshatra of your name');
      }

      var dominant = findDominantGraha(s.scores, chart);
      var graha = STONE_DB[dominant];
      var finding = buildChartFinding(chart, dominant, s.reasons);
      return {
        graha: graha,
        dominant: dominant,
        chart: chart,
        finding: finding,
        name: name || '',
        namaksharaGraha: namaksharaGraha
      };
    }

    // ============================================================
    // FULL PATRI DATA BUILDER
    // ============================================================
    // Takes a birth chart + name + birth details and returns a complete
    // patri data structure ready for rendering. The shape of this object
    // is intentionally aligned with what most Vedic astrology APIs return
    // (Prokerala, AstrologyAPI, Vedika), so we can swap in a real API
    // later without changing the renderer.
    //
    // Future: replace the body of this function with:
    //   const apiResp = await fetch(WORKER_URL, { ... });
    //   return apiResp.json();
    // ============================================================
    function buildPatriData(chart, dominant, name, dob, tob, pob) {
      var planetAbbr = { Sun:"Su", Moon:"Mo", Mars:"Ma", Mercury:"Me", Jupiter:"Ju", Venus:"Ve", Saturn:"Sa", Rahu:"Ra", Ketu:"Ke" };

      // Build planets array — one entry per graha, with all the data
      // the table and chart need.
      var planets = PLANETS.map(function (p) {
        var d = chart.planets[p];
        var status = [];
        if (d.exalted)      status.push({ label: "Exalted",     tone: "good" });
        if (d.debilitated)  status.push({ label: "Debilitated", tone: "bad"  });
        if (d.ownSign)      status.push({ label: "Own sign",    tone: "good" });
        if (d.combust)      status.push({ label: "Combust",     tone: "warn" });
        if (d.retrograde)   status.push({ label: "Retrograde",  tone: "warn" });
        if (status.length === 0) status.push({ label: "Neutral", tone: "neutral" });

        return {
          name: p,
          abbr: planetAbbr[p],
          sign: d.sign,
          house: d.house,
          degree: Math.floor(d.degree) + "° " + Math.floor((d.degree % 1) * 60) + "'",
          status: status
        };
      });

      // Build houses array — what's in each of the 12 houses.
      // Each house knows its sign (rotated from ascendant) and which
      // planets occupy it.
      var houses = [];
      for (var h = 1; h <= 12; h++) {
        var signIdx = (chart.ascendantIndex + h - 1) % 12;
        var residents = PLANETS.filter(function (p) { return chart.planets[p].house === h; });
        houses.push({
          number: h,
          sign: SIGNS[signIdx],
          signLord: SIGN_LORDS[SIGNS[signIdx]],
          meaning: HOUSE_MEANINGS[h - 1],
          residents: residents.map(function (r) { return { name: r, abbr: planetAbbr[r] }; })
        });
      }

      // Build doshas array
      var doshas = [
        {
          name: "Mangal Dosha",
          alt: "Manglik",
          present: chart.manglik,
          description: chart.manglik
            ? "Mars in your " + chart.planets.Mars.house + (chart.planets.Mars.house === 1 ? "st" : (chart.planets.Mars.house === 4 ? "th" : (chart.planets.Mars.house === 7 ? "th" : (chart.planets.Mars.house === 8 ? "th" : "th")))) + " house indicates Manglik dosha. Traditionally significant in marriage matching — usually balanced when both partners share it."
            : "Mars is favourably placed. No Manglik dosha in this chart."
        },
        {
          name: "Kaal Sarp Dosha",
          alt: "Kaal Sarpa",
          present: chart.kaalSarp,
          description: chart.kaalSarp
            ? "All seven main grahas lie on one side of the Rahu-Ketu axis, forming Kaal Sarp dosha. Often felt as a sense of being held back by unseen forces — remedied through Rahu-Ketu pujas and disciplined effort."
            : "The grahas are distributed on both sides of the Rahu-Ketu axis. No Kaal Sarp dosha is present."
        },
        {
          name: "Sade Sati",
          alt: "Saturn's 7.5",
          present: chart.sadeSati,
          description: chart.sadeSati
            ? "Saturn is currently transiting near your natal Moon — you are in the 7.5-year phase of Sade Sati. A demanding period that ultimately strengthens character through patience and effort."
            : "Saturn is not currently transiting your Moon's vicinity. Sade Sati is not active for you right now."
        }
      ];

      // Remedies for the dominant graha
      var remedyList = REMEDIES[dominant] || [];

      return {
        // Birth details — what the user typed in
        birth: {
          name: name || "",
          dob: dob,
          tob: tob,
          pob: pob || "",
          dobFormatted: formatDob(dob),
          tobFormatted: formatTob(tob)
        },
        // Core triad
        triad: {
          lagna:           { value: chart.ascendant,  lord: chart.lagnaLord },
          rashi:           { value: chart.rashi,      lord: chart.rashiLord },
          nakshatra:       { value: chart.nakshatra,  lord: chart.nakshatraLord, pada: chart.nakshatraPada, devata: chart.nakshatraDevata }
        },
        // 9 planets and 12 houses
        planets: planets,
        houses: houses,
        // Vimshottari dasha timeline
        dashaTimeline: chart.dashaTimeline,
        currentMahadasha: chart.mahadashaLord,
        // Doshas
        doshas: doshas,
        // Dominant graha + remedies
        dominantGraha: dominant,
        remedies: remedyList
      };
    }

    function formatDob(dob) {
      // YYYY-MM-DD → "15 January 1990"
      if (!dob) return "";
      var parts = dob.split('-');
      if (parts.length !== 3) return dob;
      var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
      var day = parseInt(parts[2], 10);
      var month = months[parseInt(parts[1], 10) - 1] || "";
      var year = parts[0];
      return day + " " + month + " " + year;
    }

    function formatTob(tob) {
      // HH:MM → "08:30 AM"
      if (!tob) return "";
      var parts = tob.split(':');
      if (parts.length < 2) return tob;
      var h = parseInt(parts[0], 10);
      var m = parts[1];
      if (isNaN(h)) return tob;
      var period = h >= 12 ? "PM" : "AM";
      var h12 = h % 12;
      if (h12 === 0) h12 = 12;
      return (h12 < 10 ? "0" : "") + h12 + ":" + m + " " + period;
    }

    // ============================================================
    // FULL PATRI RENDERER
    // ============================================================
    // Takes the patri data and writes it into the DOM. Pure DOM
    // manipulation — no data computation here. If we swap in a real
    // API, this function does not change.
    // ============================================================
    function renderPatri(data) {
      // Defensive: if data is missing critical structure, don't crash —
      // just show what we have. Better to render a partial patri than
      // throw and trigger the error UI when most fields are present.
      data = data || {};
      data.birth   = data.birth   || {};
      data.triad   = data.triad   || {};
      data.triad.lagna     = data.triad.lagna     || { value: '—', lord: '—' };
      data.triad.rashi     = data.triad.rashi     || { value: '—', lord: '—' };
      data.triad.nakshatra = data.triad.nakshatra || { value: '—', lord: '—', pada: '—' };
      data.planets = Array.isArray(data.planets) ? data.planets : [];
      data.houses  = Array.isArray(data.houses)  ? data.houses  : [];
      data.dashaTimeline = Array.isArray(data.dashaTimeline) ? data.dashaTimeline : [];
      data.doshas  = Array.isArray(data.doshas)  ? data.doshas  : [];
      data.remedies = Array.isArray(data.remedies) ? data.remedies : [];

      // 1. Birth details strip
      var birthGrid = section.querySelector('#vr-patri-birth');
      if (birthGrid) {
        birthGrid.innerHTML =
          patriField("Name",             data.birth.name) +
          patriField("Date of Birth",    data.birth.dobFormatted || data.birth.dob) +
          patriField("Time of Birth",    data.birth.tobFormatted || data.birth.tob) +
          patriField("Place of Birth",   data.birth.placeResolved || data.birth.pob);
      }

      // 2. Core triad
      setText('vr-patri-lagna',         data.triad.lagna.value || '—');
      setText('vr-patri-lagna-sub',     data.triad.lagna.lord ? ("Ruled by " + data.triad.lagna.lord) : '');
      setText('vr-patri-rashi',         data.triad.rashi.value || '—');
      setText('vr-patri-rashi-sub',     data.triad.rashi.lord ? ("Ruled by " + data.triad.rashi.lord) : '');
      setText('vr-patri-nakshatra',     data.triad.nakshatra.value || '—');
      setText('vr-patri-nakshatra-sub', data.triad.nakshatra.pada
        ? ("Pada " + data.triad.nakshatra.pada + (data.triad.nakshatra.lord ? (" · " + data.triad.nakshatra.lord) : ''))
        : (data.triad.nakshatra.lord || ''));

      // 3. North Indian style chart (SVG)
      var chartEl = section.querySelector('#vr-patri-chart');
      if (chartEl) {
        chartEl.innerHTML = buildNorthIndianChartSVG(data.houses, data.triad.lagna.value, data.planets);
      }

      // 4. Planet positions table
      var planetTable = section.querySelector('#vr-patri-planets');
      if (planetTable) {
        var header = '<div class="vedic-rec__patri-pt-row vedic-rec__patri-pt-header" role="row">'
          + '<span role="columnheader">Graha</span>'
          + '<span role="columnheader">Sign · Rashi</span>'
          + '<span role="columnheader">House · Bhava</span>'
          + '<span role="columnheader">Status</span>'
          + '</div>';
        var rows = data.planets.map(function (p) {
          var status = Array.isArray(p.status) && p.status.length ? p.status : [{ label: 'Neutral', tone: 'neutral' }];
          var statusHtml = status.map(function (s) {
            return '<span class="vedic-rec__patri-status vedic-rec__patri-status--' + (s.tone || 'neutral') + '">' + escapeHtml(s.label || '') + '</span>';
          }).join('');
          var topRow = '<div class="vedic-rec__patri-pt-row" role="row">'
            + '<span class="vedic-rec__patri-pt-graha" role="cell"><strong>' + escapeHtml(p.name || '') + '</strong>'
            +   (p.role ? '<span class="vedic-rec__patri-pt-role">' + escapeHtml(p.role) + '</span>' : '')
            + '</span>'
            + '<span role="cell">' + escapeHtml(p.sign || '—') + '</span>'
            + '<span role="cell">' + (p.house || '—') + (p.house ? ord(p.house) : '') + '</span>'
            + '<span role="cell">' + statusHtml + '</span>'
            + '</div>';
          // Personality interpretation — only if we have one to show
          var interpRow = '';
          if (p.interpretation) {
            interpRow = '<div class="vedic-rec__patri-pt-interp">'
              + escapeHtml(p.interpretation)
              + '</div>';
          }
          return topRow + interpRow;
        }).join('');
        planetTable.innerHTML = header + rows;
      }

      // 5. Mahadasha timeline
      var dashaList = section.querySelector('#vr-patri-dasha');
      if (dashaList) {
        dashaList.innerHTML = data.dashaTimeline.map(function (d) {
          return '<div class="vedic-rec__patri-dasha-item' + (d.isCurrent ? ' vedic-rec__patri-dasha-item--current' : '') + '">'
            + '<div class="vedic-rec__patri-dasha-lord">' + escapeHtml(d.lord || '—') + '</div>'
            + '<div class="vedic-rec__patri-dasha-period">' + (d.startYear || '—') + ' – ' + (d.endYear || '—') + '</div>'
            + '<div class="vedic-rec__patri-dasha-years">' + (d.years || '—') + ' years</div>'
            + (d.isCurrent ? '<div class="vedic-rec__patri-dasha-tag">Current</div>' : '')
            + '</div>';
        }).join('');
      }
      var dashaNote = section.querySelector('#vr-patri-dasha-note');
      if (dashaNote) {
        var current = data.dashaTimeline.find(function (d) { return d.isCurrent; });
        if (current && current.lord) {
          dashaNote.textContent = "You are currently running " + current.lord + " Mahadasha (" + current.startYear + "–" + current.endYear + "). The qualities of " + current.lord + " colour the events of this entire " + current.years + "-year chapter of your life.";
        } else {
          dashaNote.textContent = '';
        }
      }

      // 5b. Antardasha (sub-period within current Mahadasha) — only show
      // if the API actually returned one; otherwise hide the whole section.
      var antarSection = section.querySelector('#vr-patri-antardasha-section');
      var antarCurrent = section.querySelector('#vr-patri-antar-current');
      var antarNote    = section.querySelector('#vr-patri-antar-note');
      var antarList    = section.querySelector('#vr-patri-antar-list');
      var hasAntar = data.currentAntardasha && data.currentAntardasha.lord;
      if (antarSection) antarSection.hidden = !hasAntar;
      if (hasAntar) {
        var ca = data.currentAntardasha;
        var bigDasha = (current && current.lord) ? current.lord : (data.currentMahadasha || '');
        if (antarCurrent) {
          antarCurrent.innerHTML =
            '<div class="vedic-rec__patri-antar-card">'
              + '<div class="vedic-rec__patri-antar-tag">Active now</div>'
              + '<div class="vedic-rec__patri-antar-pair">'
                + '<span class="vedic-rec__patri-antar-major">' + escapeHtml(bigDasha) + '</span>'
                + '<span class="vedic-rec__patri-antar-divider">·</span>'
                + '<span class="vedic-rec__patri-antar-minor">' + escapeHtml(ca.lord) + '</span>'
              + '</div>'
              + '<div class="vedic-rec__patri-antar-period">'
                + escapeHtml(ca.start || '') + ' \u2014 ' + escapeHtml(ca.end || '')
              + '</div>'
            + '</div>';
        }
        if (antarNote) {
          antarNote.textContent = 'Within your ' + bigDasha + ' Mahadasha, the sub-period of ' + ca.lord
            + ' is currently active. Sub-periods modify the major theme \u2014 the qualities of '
            + ca.lord + ' colour daily life within this chapter.';
        }
        if (antarList) {
          var upcoming = (data.antardashaWindow || []).filter(function (a) { return !a.isCurrent; });
          if (upcoming.length) {
            antarList.innerHTML = '<p class="vedic-rec__patri-antar-list-label">Coming up next</p>'
              + '<div class="vedic-rec__patri-antar-list-grid">'
              + upcoming.map(function (a) {
                  return '<div class="vedic-rec__patri-antar-item">'
                    + '<div class="vedic-rec__patri-antar-item-lord">' + escapeHtml(a.lord || '') + '</div>'
                    + '<div class="vedic-rec__patri-antar-item-period">' + escapeHtml(a.start || '') + ' \u2014 ' + escapeHtml(a.end || '') + '</div>'
                    + '</div>';
                }).join('')
              + '</div>';
          } else {
            antarList.innerHTML = '';
          }
        }
      }

      // 6. Doshas
      var doshaGrid = section.querySelector('#vr-patri-doshas');
      if (doshaGrid) {
        doshaGrid.innerHTML = data.doshas.map(function (d) {
          var stateClass = d.present ? 'vedic-rec__patri-dosha--present' : 'vedic-rec__patri-dosha--absent';
          var stateLabel = d.present ? 'Present' : 'Not present';
          return '<div class="vedic-rec__patri-dosha ' + stateClass + '">'
            + '<div class="vedic-rec__patri-dosha-head">'
            +   '<span class="vedic-rec__patri-dosha-name">' + escapeHtml(d.name || '') + '</span>'
            +   '<span class="vedic-rec__patri-dosha-state">' + stateLabel + '</span>'
            + '</div>'
            + '<p class="vedic-rec__patri-dosha-desc">' + escapeHtml(d.description || '') + '</p>'
            + '</div>';
        }).join('');
      }

      // 6b. Yogas — auspicious combinations. Hidden if none.
      var yogaSection = section.querySelector('#vr-patri-yogas-section');
      var yogaGrid    = section.querySelector('#vr-patri-yogas');
      var yogas       = Array.isArray(data.yogas) ? data.yogas : [];
      if (yogaSection) yogaSection.hidden = yogas.length === 0;
      if (yogaGrid && yogas.length) {
        yogaGrid.innerHTML = yogas.map(function (y) {
          return '<div class="vedic-rec__patri-yoga">'
            + '<div class="vedic-rec__patri-yoga-head">'
              + '<span class="vedic-rec__patri-yoga-name">' + escapeHtml(y.name || '') + '</span>'
              + '<span class="vedic-rec__patri-yoga-mark" aria-hidden="true">\u2728</span>'
            + '</div>'
            + (y.description
                ? '<p class="vedic-rec__patri-yoga-desc">' + escapeHtml(y.description) + '</p>'
                : '')
            + '</div>';
        }).join('');
      }

      // 7. Remedies
      var remediesIntro = section.querySelector('#vr-patri-remedies-intro');
      if (remediesIntro) {
        if (data.dominantGraha && data.remedies.length) {
          remediesIntro.textContent = "Because " + data.dominantGraha + " carries the heaviest weight in your chart, these classical remedies help strengthen its blessing in your daily life:";
        } else {
          remediesIntro.textContent = '';
        }
      }
      var remediesList = section.querySelector('#vr-patri-remedies');
      if (remediesList) {
        remediesList.innerHTML = data.remedies.map(function (r) {
          return '<li>' + escapeHtml(r) + '</li>';
        }).join('');
      }
    }

    function patriField(label, value) {
      return '<div class="vedic-rec__patri-bf">'
        + '<span class="vedic-rec__patri-bf-label">' + escapeHtml(label) + '</span>'
        + '<span class="vedic-rec__patri-bf-value">' + (value ? escapeHtml(value) : '—') + '</span>'
        + '</div>';
    }

    function setText(id, val) {
      var el = section.querySelector('#' + id);
      if (el) el.textContent = val;
    }

    // ============================================================
    // NORTH INDIAN STYLE BIRTH CHART (SVG)
    // ============================================================
    // Classical "diamond" layout: a square with two diagonals and a
    // smaller square inside, dividing it into 12 triangles/quadrilaterals.
    // House 1 is the top-centre triangle, then anticlockwise.
    //
    // Layout (looking at the chart):
    //          [12]    [1]    [2]
    //              [    ]
    //          [11][   ][    ][3]
    //              [    ]
    //          [10]    [9]    [...]
    // We place 12 numbered cells in their classical positions and put
    // the planets that occupy each house inside that cell.
    // ============================================================
    function buildNorthIndianChartSVG(houses, ascendantSign, planets) {
      // 400x400 viewBox. Outer square: 0,0 to 400,400.
      // Inner diamond formed by midpoints of outer square sides.
      var W = 400;
      var H = 400;
      var mid = W / 2;

      // If houses array is missing or incomplete, derive houses from the
      // planets array instead. Each house gets a list of resident planets.
      // This makes the renderer robust against partial API responses.
      if (!Array.isArray(houses) || houses.length < 12) {
        var derived = [];
        for (var h = 1; h <= 12; h++) {
          var residents = (planets || []).filter(function (p) { return p && p.house === h; });
          derived.push({
            number:    h,
            sign:      '',
            residents: residents.map(function (r) { return { name: r.name, abbr: r.abbr }; })
          });
        }
        houses = derived;
      }

      // Coordinates for each house's CENTRE label (numbers 1-12)
      // and a small offset for placing planets below the number.
      // North Indian convention: H1 = top-centre upper, then anticlockwise.
      var housePositions = [
        // house index: { cx, cy } for the cell centre
        { x: 200, y:  90 }, // 1 — top centre upper
        { x: 110, y:  60 }, // 2 — top-left small
        { x:  60, y: 110 }, // 3 — left-top small
        { x:  90, y: 200 }, // 4 — left centre
        { x:  60, y: 290 }, // 5 — left-bottom small
        { x: 110, y: 340 }, // 6 — bottom-left small
        { x: 200, y: 310 }, // 7 — bottom centre
        { x: 290, y: 340 }, // 8 — bottom-right small
        { x: 340, y: 290 }, // 9 — right-bottom small
        { x: 310, y: 200 }, // 10 — right centre
        { x: 340, y: 110 }, // 11 — right-top small
        { x: 290, y:  60 }  // 12 — top-right small
      ];

      var cells = housePositions.map(function (pos, idx) {
        var house = houses[idx] || { number: idx + 1, residents: [] };
        var residents = Array.isArray(house.residents) ? house.residents : [];
        var planetsHtml = residents.map(function (r) {
          return '<tspan x="' + pos.x + '" dy="14" class="vrp-chart-planet">' + escapeHtml(r.abbr || '') + '</tspan>';
        }).join('');
        var ascMarker = (idx === 0) ? '<circle cx="' + pos.x + '" cy="' + (pos.y - 28) + '" r="3" class="vrp-chart-asc"/>' : '';
        return ascMarker
          + '<text x="' + pos.x + '" y="' + pos.y + '" class="vrp-chart-num" text-anchor="middle">'
          +   (house.number || (idx + 1))
          +   planetsHtml
          + '</text>';
      }).join('');

      // The frame: outer square + inner diamond + diagonals
      var frame = ''
        + '<rect x="2" y="2" width="' + (W - 4) + '" height="' + (H - 4) + '" class="vrp-chart-frame"/>'
        + '<line x1="2" y1="2" x2="' + (W - 2) + '" y2="' + (H - 2) + '" class="vrp-chart-frame"/>'
        + '<line x1="' + (W - 2) + '" y1="2" x2="2" y2="' + (H - 2) + '" class="vrp-chart-frame"/>'
        + '<polygon points="' + mid + ',2 ' + (W - 2) + ',' + mid + ' ' + mid + ',' + (H - 2) + ' 2,' + mid + '" class="vrp-chart-frame"/>';

      return '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="North Indian birth chart with ascendant in ' + escapeHtml(ascendantSign) + '">'
        + frame
        + cells
        + '</svg>';
    }

    // ============================================================
    // BRACELET VISUAL (SVG)
    // ============================================================
    function renderBracelet(color, accent, size) {
      size = size || 280;
      var beadCount = 22;
      var radius = size * 0.4;
      var center = size / 2;
      var beads = "";
      for (var i = 0; i < beadCount; i++) {
        var angle = (i / beadCount) * Math.PI * 2 - Math.PI / 2;
        var x = center + Math.cos(angle) * radius;
        var y = center + Math.sin(angle) * radius;
        var isAccent = i % 5 === 0;
        var fill = isAccent ? accent : color;
        var beadSize = isAccent ? size * 0.045 : size * 0.038;
        beads += '<circle cx="' + x + '" cy="' + y + '" r="' + beadSize + '" fill="' + fill + '" opacity="0.92"/>';
        beads += '<circle cx="' + (x - beadSize*0.3) + '" cy="' + (y - beadSize*0.3) + '" r="' + (beadSize*0.3) + '" fill="rgba(255,255,255,0.4)"/>';
      }
      return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '" xmlns="http://www.w3.org/2000/svg">' + beads + '</svg>';
    }

    // ============================================================
    // UI WIRING
    // ============================================================
    var els = {
      placeholder:    section.querySelector('#vr-placeholder'),
      resultDisplay:  section.querySelector('#vr-result-display'),
      braceletVisual: section.querySelector('#vr-bracelet-visual'),
      braceletName:   section.querySelector('#vr-bracelet-name'),
      braceletStone:  section.querySelector('#vr-bracelet-stone'),

      introStep:      section.querySelector('#vr-intro-step'),
      loadingStep:    section.querySelector('#vr-loading-step'),
      resultStep:     section.querySelector('#vr-result-step'),

      tabUpload:      section.querySelector('#vr-tab-upload'),
      tabManual:      section.querySelector('#vr-tab-manual'),
      uploadForm:     section.querySelector('#vr-upload-form'),
      manualForm:     section.querySelector('#vr-manual-form'),
      uploadZone:     section.querySelector('.vedic-rec__upload-zone'),
      fileInput:      section.querySelector('#vr-file-input'),
      fileLabel:      section.querySelector('#vr-file-label'),
      name:           section.querySelector('#vr-name'),
      dob:            section.querySelector('#vr-dob'),
      tob:            section.querySelector('#vr-tob'),
      pob:            section.querySelector('#vr-pob'),
      orientCue:      section.querySelector('#vr-orient-cue'),

      revealBtn:      section.querySelector('#vr-reveal-btn'),
      loadingText:    section.querySelector('#vr-loading-text'),
      loadingSub:     section.querySelector('#vr-loading-sub'),

      resultTitle:    section.querySelector('#vr-result-title'),
      resultDesc:     section.querySelector('#vr-result-desc'),
      chartFinding:   section.querySelector('#vr-chart-finding'),

      primaryCard:    section.querySelector('#vr-primary-card'),
      primaryImage:   section.querySelector('#vr-primary-image'),
      primaryBadge:   section.querySelector('#vr-primary-badge'),
      primaryName:    section.querySelector('#vr-primary-name'),
      primaryStone:   section.querySelector('#vr-primary-stone'),
      primaryPrice:   section.querySelector('#vr-primary-price'),

      buyBtn:         section.querySelector('#vr-buy-btn'),
      buyBtnText:     section.querySelector('#vr-buy-btn-text'),
      alternatesGrid: section.querySelector('#vr-alternates-grid'),
      verifiedBadge:  section.querySelector('#vr-verified-badge'),
      patriToggle:    section.querySelector('#vr-patri-toggle'),
      patriContent:   section.querySelector('#vr-patri-content'),
      patriLoading:   section.querySelector('#vr-patri-loading'),
      patriError:     section.querySelector('#vr-patri-error'),
      patriErrorMsg:  section.querySelector('#vr-patri-error-msg'),
      patriRetry:     section.querySelector('#vr-patri-retry'),
      patriDataEl:    section.querySelector('#vr-patri-data'),
      resetBtn:       section.querySelector('#vr-reset-btn')
    };

    var currentRecommendation = null;
    // Hardcoded base URL — avoids edge cases where window.location.origin
    // returns null/empty (some embedded contexts, older browsers, JSDOM).
    var ETCHCRAFT_BASE = 'https://etchcraftemporium.in';

    // Worker URL for the real Prokerala-backed patri API. Read from the
    // section's data attribute (set in the Theme Customizer). When empty,
    // the patri toggle stays hidden — we never show the toggle if we
    // can't fulfil it with real data.
    var PATRI_WORKER_URL = (section.dataset.patriWorkerUrl || '').trim();

    // Cache of patri results keyed by birth-detail signature. Lets the
    // user collapse and re-expand without re-fetching.
    var patriCache = {};

    // Cache of full worker responses (chart + patri) keyed by birth
    // signature. Reused if the same person clicks Reveal twice.
    var workerResponseCache = {};

    // ============================================================
    // ANALYTICS — funnel tracking
    // ============================================================
    // We fire events at every meaningful funnel step. Three sinks:
    //
    //   1. window.dataLayer  — Google Tag Manager / GA4 standard
    //   2. window.gtag       — direct GA4 (if loaded without GTM)
    //   3. Worker /track     — server-side counter for the admin dashboard
    //
    // Each is opt-in: if dataLayer/gtag aren't on the page, we no-op
    // silently. The Worker call is fire-and-forget; failures don't
    // affect user experience.
    //
    // No personally identifiable info is ever sent. Names and birth
    // details stay client-side. Events carry only chart-derived facts
    // (dominant graha, lagna sign) and product handles.
    // ============================================================
    var sectionViewedFired = false;
    var formStartedFired   = false;

    function track(eventName, props) {
      props = props || {};
      // Add a session-stable anonymous id so we can group events
      // belonging to the same visitor without storing identity.
      props.session_id = getOrCreateSessionId();

      // 1. dataLayer (works with GTM, GA4, Klaviyo, most setups)
      try {
        if (typeof window !== 'undefined' && window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push(Object.assign({ event: eventName }, props));
        }
      } catch (e) { /* noop */ }

      // 2. Direct gtag fallback (only fires if dataLayer wasn't already
      // forwarding — GTM auto-forwards, so this is mostly a no-op when
      // GTM is present; harmless duplicate when both fire)
      try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function' && !window.dataLayer) {
          window.gtag('event', eventName, props);
        }
      } catch (e) { /* noop */ }

      // 3. Worker-side counter — for the admin dashboard. Fire-and-forget.
      try {
        if (PATRI_WORKER_URL) {
          var url = PATRI_WORKER_URL.replace(/\/+$/, '') + '/track';
          var body = JSON.stringify({ event: eventName, props: props });
          // Prefer sendBeacon — works during page unload, doesn't block UI.
          if (navigator.sendBeacon) {
            navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
          } else {
            fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: body,
              keepalive: true
            }).catch(function () { /* noop */ });
          }
        }
      } catch (e) { /* noop */ }
    }

    /**
     * A short anonymous id stored in sessionStorage. Lets us group events
     * across a single visit without identifying the person. Cleared when
     * the user closes the tab.
     */
    function getOrCreateSessionId() {
      try {
        var existing = window.sessionStorage && sessionStorage.getItem('vr_sid');
        if (existing) return existing;
        var sid = 'sid_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
        if (window.sessionStorage) sessionStorage.setItem('vr_sid', sid);
        return sid;
      } catch (e) { return 'sid_anon'; }
    }

    /**
     * Lazy-fire the section_view event when the user actually scrolls
     * the recommender into view (not on every page load).
     */
    function fireSectionView() {
      if (sectionViewedFired) return;
      sectionViewedFired = true;
      track('vedic_section_view', { section_id: section.id || '' });
    }
    if (typeof IntersectionObserver !== 'undefined') {
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              fireSectionView();
              io.disconnect();
            }
          });
        }, { threshold: 0.25 });
        io.observe(section);
      } catch (e) { fireSectionView(); }
    } else {
      fireSectionView();
    }

    // Fire form_started the first time the user touches an input
    var formInputs = section.querySelectorAll(
      '#vr-name, #vr-dob, #vr-tob, #vr-pob, #vr-tab-manual, #vr-tab-upload'
    );
    formInputs.forEach(function (el) {
      el.addEventListener('focus', function () {
        if (formStartedFired) return;
        formStartedFired = true;
        track('vedic_form_started', {});
      }, { once: true, passive: true });
    });

    // ===== Tabs =====
    var currentTab = 'upload'; // initial tab matches the markup
    function switchTab(which) {
      currentTab = which;
      if (which === 'upload') {
        els.tabUpload.classList.add('vedic-rec__tab--active');
        els.tabUpload.setAttribute('aria-selected', 'true');
        els.tabManual.classList.remove('vedic-rec__tab--active');
        els.tabManual.setAttribute('aria-selected', 'false');
        els.uploadForm.hidden = false;
        els.manualForm.hidden = true;
      } else {
        els.tabManual.classList.add('vedic-rec__tab--active');
        els.tabManual.setAttribute('aria-selected', 'true');
        els.tabUpload.classList.remove('vedic-rec__tab--active');
        els.tabUpload.setAttribute('aria-selected', 'false');
        els.manualForm.hidden = false;
        els.uploadForm.hidden = true;
      }
    }
    els.tabUpload.addEventListener('click', function () { switchTab('upload'); });
    els.tabManual.addEventListener('click', function () { switchTab('manual'); });

    // ===== Upload =====
    if (els.uploadZone && els.fileInput) {
      els.uploadZone.addEventListener('click', function () { els.fileInput.click(); });
      els.uploadZone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); els.fileInput.click(); }
      });
      els.fileInput.addEventListener('change', function () {
        if (els.fileInput.files && els.fileInput.files.length) {
          els.fileLabel.textContent = els.fileInput.files[0].name;
        }
      });
    }

    // ===== Reveal =====
    els.revealBtn.addEventListener('click', startAnalysis);
    els.resetBtn.addEventListener('click', resetFlow);
    els.buyBtn.addEventListener('click', goToBuy);

    // ===== Full Patri toggle =====
    // When the user clicks the toggle, we (1) show the patri panel, (2) check
    // the cache for this birth detail combo, (3) if cache miss, fetch from
    // the Cloudflare Worker (which proxies Prokerala's Swiss Ephemeris API),
    // (4) render the data on success, or show a friendly error with retry
    // button on failure. We never silently fall back to local-engine data
    // here — the user clicked expecting a real reading, and giving them
    // anything else would be misleading.
    function togglePatri() {
      if (!els.patriToggle || !els.patriContent) return;
      var expanded = els.patriToggle.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        // ----- Collapse -----
        els.patriToggle.setAttribute('aria-expanded', 'false');
        els.patriContent.classList.remove('vedic-rec__patri-content--open');
        setTimeout(function () {
          if (els.patriToggle.getAttribute('aria-expanded') === 'false') {
            els.patriContent.hidden = true;
          }
        }, 400);
        return;
      }

      // ----- Expand -----
      els.patriContent.hidden = false;
      void els.patriContent.offsetHeight;  // force reflow for transition
      els.patriContent.classList.add('vedic-rec__patri-content--open');
      els.patriToggle.setAttribute('aria-expanded', 'true');

      // Track patri engagement — high-intent action
      track('vedic_patri_opened', {
        dominant_graha: (currentRecommendation && currentRecommendation.dominant) || ''
      });

      // Smooth-scroll the patri into view after the unfold animation
      setTimeout(function () {
        if (els.patriContent && typeof els.patriContent.scrollIntoView === 'function') {
          try {
            els.patriContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch (_) { /* ignore unsupported options */ }
        }
      }, 300);

      // The patri data was loaded as part of the bracelet recommendation
      // (single worker call returns both). So we just render — no fetch.
      if (currentRecommendation && currentRecommendation.patriData) {
        // Customise remedies to match the engine's chosen dominant graha
        // (which may differ from the worker's "current dasha lord" default
        // because the engine factors in afflictions + namakshara bonus).
        try {
          var pd = Object.assign({}, currentRecommendation.patriData);
          if (currentRecommendation.dominant) {
            pd.dominantGraha = currentRecommendation.dominant;
            pd.remedies = REMEDIES[currentRecommendation.dominant] || pd.remedies || [];
          }
          showPatriData(pd);
        } catch (e) {
          console.warn('[Vedic Recommender] Patri render failed:', e);
          showPatriError('Something went wrong displaying your patri.');
        }
      } else {
        // Edge case: bracelet result is showing but no patri data attached.
        // Shouldn't happen with the new flow, but fall back to a fetch.
        fetchAndRenderPatri();
      }
    }

    /**
     * Build a unique cache key for a recommendation's birth details.
     * Two readings with identical inputs share the same key (and the same
     * cached result), so re-toggling never re-fetches.
     */
    function patriCacheKey(rec) {
      return [rec.dob || '', rec.tob || '', rec.pob || '', rec.name || ''].join('|');
    }

    /**
     * Show the loading state inside the patri panel.
     * Hides data and error states.
     */
    function showPatriLoading() {
      if (els.patriLoading) els.patriLoading.hidden = false;
      if (els.patriError)   els.patriError.hidden   = true;
      if (els.patriDataEl)  els.patriDataEl.hidden  = true;
    }

    /**
     * Show an error state inside the patri panel with an optional message
     * and a working "Try Again" button.
     */
    function showPatriError(message) {
      if (els.patriLoading) els.patriLoading.hidden = true;
      if (els.patriDataEl)  els.patriDataEl.hidden  = true;
      if (els.patriErrorMsg && message) {
        els.patriErrorMsg.textContent = message;
      }
      if (els.patriError)   els.patriError.hidden   = false;
    }

    /**
     * Render the patri data. Hides loading/error and shows the data area.
     */
    function showPatriData(data) {
      if (els.patriLoading) els.patriLoading.hidden = true;
      if (els.patriError)   els.patriError.hidden   = true;
      try {
        renderPatri(data);
      } catch (e) {
        console.warn('[Vedic Recommender] renderPatri failed:', e);
        showPatriError('Something went wrong displaying your patri.');
        return;
      }
      if (els.patriDataEl)  els.patriDataEl.hidden  = false;
    }

    /**
     * Fetch the patri from the Cloudflare Worker and render. Shows loading
     * state during the fetch, error state on failure with a retry option.
     */
    function fetchAndRenderPatri() {
      if (!currentRecommendation) return;

      // No worker configured — should never happen (toggle would be hidden),
      // but defend against misconfiguration anyway.
      if (!PATRI_WORKER_URL) {
        showPatriError('The patri service is not yet configured for this site.');
        return;
      }

      showPatriLoading();

      var rec = currentRecommendation;
      var payload = {
        name: rec.name || '',
        dob:  rec.dob,
        tob:  rec.tob,
        pob:  rec.pob
      };

      // 20-second timeout — Prokerala usually responds in 2-3s; if we're
      // waiting longer than 20s something is wrong.
      var timedOut = false;
      var timeoutId = setTimeout(function () {
        timedOut = true;
        showPatriError('The patri service is taking longer than usual. Please try again in a moment.');
      }, 20000);

      fetch(PATRI_WORKER_URL.replace(/\/+$/, '') + '/patri', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(payload)
      }).then(function (resp) {
        if (!resp.ok) {
          // Worker returned an error status — read the body for the message
          return resp.json().catch(function () { return { error: 'Service error ' + resp.status }; })
            .then(function (errData) { throw new Error(errData.error || 'Service error'); });
        }
        return resp.json();
      }).then(function (data) {
        clearTimeout(timeoutId);
        if (timedOut) return; // timeout already fired the error UI
        if (!data || data.error) {
          throw new Error((data && data.error) || 'Unknown error');
        }
        // Cache the result for future toggles in this session
        var key = patriCacheKey(rec);
        patriCache[key] = data;
        showPatriData(data);
      }).catch(function (err) {
        clearTimeout(timeoutId);
        if (timedOut) return;
        console.warn('[Vedic Recommender] Patri fetch failed:', err);
        var msg = (err && err.message) || 'The patri service is temporarily unavailable.';
        // Translate raw API errors into friendlier messages where we can
        if (/place/i.test(msg)) {
          msg = 'We couldn\u2019t find that birth place. Try a major nearby city.';
        }
        showPatriError(msg);
      });
    }

    if (els.patriToggle) {
      els.patriToggle.addEventListener('click', togglePatri);
    }
    if (els.patriRetry) {
      els.patriRetry.addEventListener('click', fetchAndRenderPatri);
    }

    // If no Worker URL is configured in the section settings, the patri
    // feature stays hidden entirely. We never show a toggle that can't be
    // fulfilled with real readings.
    if (!PATRI_WORKER_URL) {
      var patriBlock = section.querySelector('.vedic-rec__patri-block');
      if (patriBlock) patriBlock.style.display = 'none';
    }

    // ===== Orientation cue =====
    // Goal: tell users where to start. Stays visible until they actually
    // begin typing their name. The pill itself is in normal document flow
    // (above the name field), so it's always visible without scroll trickery.
    //
    // The name input also gets a continuous gold ring pulse for peripheral
    // visibility. Both stop the moment the user starts typing.
    var orientWrap = section.querySelector('.vedic-rec__orient-wrap');

    function dismissOrientCue() {
      if (orientWrap && !orientWrap.classList.contains('vedic-rec__orient-wrap--gone')) {
        orientWrap.classList.add('vedic-rec__orient-wrap--gone');
      }
      if (els.name) {
        els.name.classList.remove('vedic-rec__name-pulse');
      }
    }

    if (els.name) {
      // Apply continuous pulsing ring to the name input — runs until dismissed
      els.name.classList.add('vedic-rec__name-pulse');

      // Dismiss when the user actually types something (not on focus/click,
      // because exploring the form shouldn't penalise you)
      els.name.addEventListener('input', function onFirstType() {
        if (els.name.value.trim().length > 0) {
          dismissOrientCue();
          els.name.removeEventListener('input', onFirstType);
        }
      });
    }

    // Also dismiss the moment the user clicks the reveal button (final fallback)
    if (els.revealBtn) {
      els.revealBtn.addEventListener('click', dismissOrientCue, { once: true });
    }

    function startAnalysis() {
      try {
        var name = (els.name && els.name.value || '').trim();
        var dob = (els.dob && els.dob.value) || '';
        var tob = (els.tob && els.tob.value) || '';
        var pob = (els.pob && els.pob.value || '').trim();

        // Track that the user attempted a reading (before validation, so
        // we can also see how many submissions failed validation downstream)
        track('vedic_form_submitted', { tab: currentTab });

        // Validation: name is always required
        if (!name) {
          flagInvalid(els.name, 'Please enter your name to begin');
          if (els.name) els.name.focus();
          track('vedic_form_error', { stage: 'validation', field: 'name' });
          return;
        }
        // Name should be at least 2 chars and contain a letter
        if (name.length < 2 || !/[a-zA-Z\u0900-\u097F]/.test(name)) {
          flagInvalid(els.name, 'Please enter a valid name');
          if (els.name) els.name.focus();
          return;
        }

        // Validation: when on manual tab, all three time fields are required AND valid
        if (currentTab === 'manual') {
          // DOB required
          if (!dob) {
            flagInvalid(els.dob, 'Date of birth is required');
            if (els.dob) els.dob.focus();
            return;
          }

          // DOB must be a valid date in a plausible range
          var dobError = validateDob(dob);
          if (dobError) {
            flagInvalid(els.dob, dobError);
            if (els.dob) els.dob.focus();
            return;
          }

          // Time of birth required
          if (!tob) {
            flagInvalid(els.tob, 'Time of birth is required');
            if (els.tob) els.tob.focus();
            return;
          }
          // Validate time format (must be HH:MM in 24-hour range)
          var tobError = validateTob(tob);
          if (tobError) {
            flagInvalid(els.tob, tobError);
            if (els.tob) els.tob.focus();
            return;
          }

          // Place required
          if (!pob) {
            flagInvalid(els.pob, 'Place of birth is required');
            if (els.pob) els.pob.focus();
            return;
          }
          // Place must look like a real place name (rejects keyboard mash like "asdfgh")
          var pobError = validatePob(pob);
          if (pobError) {
            flagInvalid(els.pob, pobError);
            if (els.pob) els.pob.focus();
            return;
          }
        }

        // Defaults for upload-tab flow (until upload parsing is wired up)
        if (!dob) dob = '1990-01-15';
        if (!tob) tob = '08:30';
        if (!pob) pob = 'Delhi';

        if (els.introStep)   els.introStep.hidden = true;
        if (els.loadingStep) els.loadingStep.hidden = false;

        var firstName = name.split(/\s+/)[0];
        var stages = [
          { text: 'Casting your kundali, ' + firstName,  sub: 'Calculating planetary positions' },
          { text: 'Reading the nine grahas',             sub: 'Analyzing house placements' },
          { text: 'Identifying your Namakshara',         sub: 'Mapping the nakshatra of your name' },
          { text: 'Locating your Lagna',                 sub: 'Finding the ruling graha of your chart' },
          { text: 'Reading your Mahadasha',              sub: 'Identifying the planet shaping this chapter' },
          { text: 'Scoring afflictions',                 sub: 'Weighing each graha against your destiny' },
          { text: 'Matching your stone',                 sub: 'Consulting classical Jyotish' }
        ];

        if (els.loadingText) els.loadingText.textContent = stages[0].text;
        if (els.loadingSub)  els.loadingSub.textContent  = stages[0].sub;

        // ============================================================
        // KICK OFF REAL DATA FETCH IN PARALLEL WITH LOADING ANIMATION
        // ============================================================
        // The bracelet recommendation now requires real Swiss Ephemeris
        // data from the worker. We fetch it here, in parallel with the
        // loading animation, so the user-perceived wait isn't the sum
        // of both. We only proceed to showResult when BOTH:
        //   (a) the animation has played all stages (visual completeness)
        //   (b) the worker fetch has resolved (real data available)
        // ============================================================
        if (!PATRI_WORKER_URL) {
          // No worker configured — show clear error rather than fake data.
          if (els.loadingStep) els.loadingStep.hidden = true;
          if (els.introStep)   els.introStep.hidden = false;
          alert('The reading service is not yet configured. Please contact the site owner.');
          return;
        }

        var workerData    = null;
        var workerError   = null;
        var animationDone = false;

        // Cache key — normalised so trivial whitespace/case differences in
        // name or place don't cause a re-fetch (or worse, two cached entries
        // for what users perceive as the same input).
        var cacheKey = [
          dob,
          tob,
          (pob || '').toLowerCase().replace(/\s+/g, ' ').trim(),
          (name || '').toLowerCase().replace(/\s+/g, ' ').trim()
        ].join('|');
        var workerPromise;
        if (workerResponseCache[cacheKey]) {
          workerData    = workerResponseCache[cacheKey];
          workerPromise = Promise.resolve(workerData);
        } else {
          workerPromise = fetch(PATRI_WORKER_URL.replace(/\/+$/, '') + '/patri', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: name, dob: dob, tob: tob, pob: pob })
          }).then(function (resp) {
            if (!resp.ok) {
              return resp.json().catch(function () { return { error: 'Service error ' + resp.status }; })
                .then(function (errData) { throw new Error(errData.error || 'Service error'); });
            }
            return resp.json();
          }).then(function (data) {
            if (!data || data.error) throw new Error((data && data.error) || 'Unknown error');
            workerResponseCache[cacheKey] = data;
            workerData = data;
            return data;
          }).catch(function (err) {
            workerError = err;
          });
        }

        // Run the loading-stages animation
        var i = 0;
        var interval = setInterval(function () {
          i++;
          if (i < stages.length) {
            if (els.loadingText) els.loadingText.textContent = stages[i].text;
            if (els.loadingSub)  els.loadingSub.textContent  = stages[i].sub;
            return;
          }
          clearInterval(interval);
          animationDone = true;
          maybeFinish();
        }, 1000);

        // After both the animation and the fetch are done, show the result
        function maybeFinish() {
          if (!animationDone) return;
          if (workerError) {
            // Real failure — tell the user, don't fall back to fake data
            if (els.loadingStep) els.loadingStep.hidden = true;
            if (els.introStep)   els.introStep.hidden = false;
            var msg = (workerError && workerError.message) || 'The reading service is temporarily unavailable.';
            if (/place/i.test(msg)) {
              msg = 'We couldn\u2019t find that birth place. Try a major nearby city.';
            }
            track('vedic_form_error', { stage: 'api', error: (msg || 'unknown').slice(0, 80) });
            alert(msg + ' Please try again.');
            return;
          }
          if (!workerData) {
            // Animation finished but fetch still in flight — show a "still working" stage
            if (els.loadingText) els.loadingText.textContent = 'Casting your kundali';
            if (els.loadingSub)  els.loadingSub.textContent  = 'Connecting with the cosmic data\u2026';
            return; // maybeFinish will be called again when the fetch resolves
          }
          // Both ready — score grahas using the REAL chart and pick a bracelet
          var result;
          try {
            result = recommendBraceletFromChart(workerData.chart, name);
            // Pass through the patri data so showResult can stash it
            result.patriData = workerData.patri;
            // Carry the data-source identifier so the verified badge can
            // confirm we're showing real Swiss Ephemeris data, not a fallback
            result.workerSource = workerData.source;
            // Pass through birth details for any downstream use
            result.dob = dob; result.tob = tob; result.pob = pob;
          } catch (engineErr) {
            console.error('[Vedic Recommender] Engine error:', engineErr);
            if (els.loadingStep) els.loadingStep.hidden = true;
            if (els.introStep)   els.introStep.hidden = false;
            alert('Something went wrong while preparing your reading. Please try again.');
            return;
          }
          try {
            showResult(result);
          } catch (renderErr) {
            console.error('[Vedic Recommender] Render error (non-fatal):', renderErr);
          }
        }

        // Plug the promise resolution into maybeFinish
        workerPromise.then(maybeFinish);
      } catch (err) {
        console.error('[Vedic Recommender] startAnalysis error:', err);
        alert('Something went wrong. Please refresh the page and try again.');
      }
    }

    /**
     * Validate a date-of-birth string in YYYY-MM-DD format.
     * Returns an error message if invalid, or null if valid.
     *
     * Rules:
     * - Must match YYYY-MM-DD format
     * - Year between 1925 and current year
     * - Must be a real calendar date (no Feb 30 etc.)
     * - Cannot be a future date
     */
    function validateDob(dobStr) {
      if (!dobStr || typeof dobStr !== 'string') return 'Date of birth is required';
      // Format check: YYYY-MM-DD
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dobStr)) {
        return 'Please enter a valid date';
      }
      var parts = dobStr.split('-');
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10);
      var day = parseInt(parts[2], 10);

      var now = new Date();
      var currentYear = now.getFullYear();

      // Year sanity — covers anyone alive today, rejects 9999 and 1700
      if (year < 1925) return 'Birth year must be 1925 or later';
      if (year > currentYear) return 'Birth year cannot be in the future';

      // Month sanity
      if (month < 1 || month > 12) return 'Please enter a valid month';

      // Day sanity (also catches Feb 30, Apr 31, etc.)
      if (day < 1 || day > 31) return 'Please enter a valid day';

      // Construct a real Date and verify the components round-trip.
      // If you give Date(2025, 1, 30), it silently becomes March 2 — so the
      // round-trip catches invalid dates like Feb 30.
      var d = new Date(year, month - 1, day);
      if (
        d.getFullYear() !== year ||
        d.getMonth() !== month - 1 ||
        d.getDate() !== day
      ) {
        return 'That date does not exist on the calendar';
      }

      // Future-date check (whole calendar day)
      var todayStart = new Date(currentYear, now.getMonth(), now.getDate());
      if (d > todayStart) {
        return 'Birth date cannot be in the future';
      }

      return null;
    }

    /**
     * Validate a time-of-birth string in HH:MM format (24-hour).
     * Browser <input type="time"> always returns 24-hour format when the
     * value is set, OR returns empty string if the user didn't fully select
     * (e.g. forgot AM/PM on iOS). Empty case is caught by the required check.
     * Returns an error message if invalid, or null if valid.
     */
    function validateTob(tobStr) {
      if (!tobStr || typeof tobStr !== 'string') return 'Time of birth is required';
      // Must be HH:MM strictly (browsers may return HH:MM:SS but we enforce HH:MM)
      var m = tobStr.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
      if (!m) return 'Please enter a valid time (e.g. 14:30)';
      var hh = parseInt(m[1], 10);
      var mm = parseInt(m[2], 10);
      if (isNaN(hh) || isNaN(mm)) return 'Please enter a valid time';
      if (hh < 0 || hh > 23) return 'Hour must be between 0 and 23';
      if (mm < 0 || mm > 59) return 'Minutes must be between 0 and 59';
      return null;
    }

    /**
     * Validate a place-of-birth string. We can't perfectly verify a place
     * name without a geocoding API, but we can reject obvious garbage:
     * - Too short
     * - All-consonants or all-vowels (keyboard mash)
     * - Known keyboard patterns (qwerty, asdf, zxcv, etc.)
     * - No vowels at all
     * - Too many consecutive identical letters
     * Returns an error message if invalid, or null if valid.
     */
    function validatePob(pobStr) {
      if (!pobStr || typeof pobStr !== 'string') return 'Place of birth is required';
      var s = pobStr.trim();
      if (s.length < 3) return 'Please enter your full city or town name';

      // Must contain at least one letter (English or Devanagari)
      if (!/[a-zA-Z\u0900-\u097F]/.test(s)) return 'Please enter a valid place name';

      // Devanagari script is hard to validate phonetically without a dictionary;
      // accept any string with Devanagari letters past the basic checks above.
      if (/[\u0900-\u097F]/.test(s)) return null;

      var lower = s.toLowerCase();

      // Strip non-letter characters for pattern checks
      var letters = lower.replace(/[^a-z]/g, '');
      if (letters.length < 3) return 'Please enter your full city or town name';

      // Reject if no proper vowel (real place names virtually always have a/e/i/o/u).
      // Note: 'y' alone isn't a real vowel for this purpose — "xyzpqr" should fail.
      if (!/[aeiou]/.test(letters)) {
        return 'That doesn\u2019t look like a valid place name';
      }

      // Reject if no consonants either
      if (!/[bcdfghjklmnpqrstvwxz]/.test(letters)) {
        return 'That doesn\u2019t look like a valid place name';
      }

      // Reject 4+ consecutive identical letters (e.g. "aaaa")
      if (/(.)\1{3,}/.test(letters)) {
        return 'That doesn\u2019t look like a valid place name';
      }

      // Reject 5+ consecutive consonants (e.g. "qwrtp")
      if (/[bcdfghjklmnpqrstvwxz]{5,}/.test(letters)) {
        return 'That doesn\u2019t look like a valid place name';
      }

      // Reject keyboard-mash patterns
      var keyboardPatterns = [
        'qwerty', 'qwert', 'wert', 'asdf', 'asdfg', 'sdfg', 'zxcv', 'zxcvb',
        'qwer', 'asdfgh', 'asdfghj', 'qazwsx', 'qweasd', 'wasd',
        'aasd', 'aasda', 'aasdas', 'sdas', 'asda', 'asdas',
        'lkjh', 'mnbv', 'poiu', 'rewq', 'ytre',
        '12345', 'abcd', 'abcde', 'bcdef'
      ];
      for (var i = 0; i < keyboardPatterns.length; i++) {
        if (lower.indexOf(keyboardPatterns[i]) !== -1) {
          return 'That doesn\u2019t look like a valid place name';
        }
      }

      // Reject if the string is all the same 2-3 letters repeated (e.g. "ababab")
      var uniqueChars = {};
      for (var j = 0; j < letters.length; j++) {
        uniqueChars[letters[j]] = true;
      }
      if (Object.keys(uniqueChars).length < 3 && letters.length >= 4) {
        return 'That doesn\u2019t look like a valid place name';
      }

      return null;
    }

    function flagInvalid(input, msg) {
      if (!input) return;
      input.classList.add('vedic-rec__field-error');
      // Remove error styling on next input
      var clear = function () {
        input.classList.remove('vedic-rec__field-error');
        input.removeEventListener('input', clear);
      };
      input.addEventListener('input', clear);

      // Show inline error message
      var existing = input.parentNode.querySelector('.vedic-rec__field-error-msg');
      if (existing) existing.remove();
      var err = document.createElement('p');
      err.className = 'vedic-rec__field-error-msg';
      err.textContent = msg;
      input.parentNode.appendChild(err);
      var clearMsg = function () {
        if (err && err.parentNode) err.remove();
        input.removeEventListener('input', clearMsg);
      };
      input.addEventListener('input', clearMsg);
    }

    function showResult(result) {
      currentRecommendation = result;
      var graha = result.graha;
      var dominant = result.dominant;
      var finding = result.finding;
      var chart = result.chart;
      var primary = graha.candidates[0];

      // Track that the user successfully completed a reading. This is the
      // numerator for "% of submissions that became readings" — gives us
      // the validation drop-off rate.
      track('vedic_reading_completed', {
        dominant_graha: dominant || '',
        lagna_sign:     (chart && chart.ascendant) || '',
        primary_handle: (primary && primary.handle) || '',
        is_real_data:   result.workerSource === 'prokerala'
      });

      els.loadingStep.hidden = true;
      els.resultStep.hidden = false;
      els.placeholder.hidden = true;
      els.resultDisplay.hidden = false;

      // Verified badge — visible ONLY when the bracelet was scored on real
      // Swiss Ephemeris data (Prokerala). The patriData carries `source`
      // through from the worker's response. If it's missing or anything
      // other than 'prokerala', the badge stays hidden — never lie about
      // the data source.
      if (els.verifiedBadge) {
        var isReal = result.patriData && result.patriData.source === 'prokerala';
        // Note: with the new architecture, patriData.source isn't set
        // (the worker returns source at the top level, not inside patri).
        // Check both locations for safety.
        if (!isReal && result.workerSource === 'prokerala') isReal = true;
        els.verifiedBadge.hidden = !isReal;
      }

      // Left panel
      els.braceletVisual.innerHTML = renderBracelet(primary.color, primary.accent, 280);
      els.braceletName.textContent = primary.name.replace(/\(Personalised\)/i, '').trim();
      els.braceletStone.textContent = primary.stone;

      // Right panel narrative
      els.resultTitle.textContent = graha.title;
      var firstName = (result.name || '').split(/\s+/)[0];
      var greeting = firstName ? firstName + ', ' : '';
      var lagnaLine = greeting + "your Lagna rises in " + chart.ascendant + ", ruled by " + chart.lagnaLord + ".";
      var dashaLine = "You are currently running " + chart.mahadashaLord + " Mahadasha.";
      var namaksharaLine = "";
      if (result.namaksharaGraha === dominant) {
        namaksharaLine = " Your name itself carries the imprint of " + dominant + " — your Namakshara aligns with the very graha calling for support.";
      } else if (result.namaksharaGraha) {
        namaksharaLine = " Your Namakshara (the nakshatra of your name) is ruled by " + result.namaksharaGraha + ".";
      }
      var dominantLine = "Of all nine grahas, " + dominant + " (" + graha.grahaTitle + ") carries the heaviest weight in your chart right now." + namaksharaLine + " " + graha.desc;
      els.resultDesc.textContent = lagnaLine + " " + dashaLine + " " + dominantLine;
      els.chartFinding.textContent = finding;

      // ============================================================
      // Primary product card — bulletproof link setup
      // ============================================================
      // Strategy:
      //   1. Always derive a valid URL from the handle (with fallback)
      //   2. Set href on BOTH .href property AND href attribute
      //   3. Attach a click handler that programmatically navigates,
      //      so even if the anchor's default click doesn't fire (popup
      //      blocker, theme JS preventing default, etc.), it still works
      //   4. Use window.location.href as final fallback if window.open fails
      var productUrl = buildProductUrl(primary.handle, currentRecommendation);
      els.primaryCard.href = productUrl;
      els.primaryCard.setAttribute('href', productUrl);
      els.primaryCard.setAttribute('target', '_blank');
      els.primaryCard.setAttribute('rel', 'noopener');

      // Detach old handler if re-rendering
      if (els.primaryCard._vrClickHandler) {
        els.primaryCard.removeEventListener('click', els.primaryCard._vrClickHandler);
      }
      els.primaryCard._vrClickHandler = function (e) {
        // Always handle the click programmatically — never trust the default
        e.preventDefault();
        track('vedic_bracelet_clicked', {
          position:        'primary',
          dominant_graha:  dominant || '',
          product_handle:  primary.handle || '',
          product_price:   primary.price || 0
        });
        openProductPage(productUrl);
      };
      els.primaryCard.addEventListener('click', els.primaryCard._vrClickHandler);

      els.primaryImage.src = primary.image;
      els.primaryImage.alt = primary.name;
      els.primaryName.textContent = primary.name.replace(/\(Personalised\)/i, '').trim();
      els.primaryStone.textContent = primary.stone;
      els.primaryPrice.textContent = "₹" + primary.price.toLocaleString('en-IN');
      if (primary.bestseller) {
        els.primaryBadge.hidden = false;
      } else {
        els.primaryBadge.hidden = true;
      }

      // Alternates — pick 2 from the remaining pool, rotated deterministically
      // by the user's chart seed. This ensures every product in the pool
      // gets exposure across the user base while keeping each user's result
      // consistent (same DOB always produces the same alternates).
      var pool = graha.candidates.slice(1); // everything except the primary
      var alts;
      if (pool.length <= 2) {
        // Small pool — show everything we have
        alts = pool;
      } else {
        // Larger pool — pick 2 deterministically using the chart's seed
        var seed = (chart.ascendantIndex || 0) * 31
                 + (chart.planets && chart.planets[dominant] ? chart.planets[dominant].house : 0) * 7
                 + (chart.mahadashaLord ? chart.mahadashaLord.charCodeAt(0) : 0);
        var startIdx = Math.abs(seed) % pool.length;
        alts = [
          pool[startIdx],
          pool[(startIdx + 1) % pool.length]
        ];
      }

      els.alternatesGrid.innerHTML = alts.filter(function (c) {
        // Drop any candidate without a valid handle so we never render a broken link
        return c && c.handle && /^[a-z0-9][a-z0-9-]+$/i.test(c.handle);
      }).map(function (c) {
        // Use the same URL builder as the primary card — keeps attribution consistent
        var altUrl = buildProductUrl(c.handle, currentRecommendation);
        return '<a class="vedic-rec__alt-card" href="' + altUrl + '" target="_blank" rel="noopener"'
          + ' data-handle="' + escapeHtml(c.handle || '') + '"'
          + ' data-price="' + (c.price || 0) + '">'
          + '<img src="' + escapeHtml(c.image || '') + '" alt="' + escapeHtml(c.name || '') + '" loading="lazy"/>'
          + '<p class="vedic-rec__alt-name">' + escapeHtml((c.name || '').replace(/\(Personalised\)/i, '').trim()) + '</p>'
          + '<p class="vedic-rec__alt-price">₹' + (c.price || 0).toLocaleString('en-IN') + '</p>'
          + '</a>';
      }).join('');

      // Track alternate clicks via event delegation (innerHTML wipes any
      // listeners on previous alternates, so we attach to the parent once)
      if (!els.alternatesGrid._vrTrackingAttached) {
        els.alternatesGrid.addEventListener('click', function (e) {
          var card = e.target.closest('.vedic-rec__alt-card');
          if (!card) return;
          track('vedic_bracelet_clicked', {
            position:        'alternate',
            dominant_graha:  (currentRecommendation && currentRecommendation.dominant) || '',
            product_handle:  card.getAttribute('data-handle') || '',
            product_price:   parseInt(card.getAttribute('data-price'), 10) || 0
          });
        });
        els.alternatesGrid._vrTrackingAttached = true;
      }

      // ============================================================
      // FULL PATRI — reset toggle state on every new reading. The actual
      // patri data is fetched from the Cloudflare Worker only when the
      // user clicks the toggle (see togglePatri / fetchAndRenderPatri).
      // ============================================================
      if (els.patriToggle) els.patriToggle.setAttribute('aria-expanded', 'false');
      if (els.patriContent) {
        els.patriContent.hidden = true;
        els.patriContent.classList.remove('vedic-rec__patri-content--open');
      }
      // Hide all three patri internal states until the user expands
      if (els.patriLoading) els.patriLoading.hidden = true;
      if (els.patriError)   els.patriError.hidden   = true;
      if (els.patriDataEl)  els.patriDataEl.hidden  = true;

      var recommender = section.querySelector('#recommender');
      if (recommender && typeof recommender.scrollIntoView === 'function') {
        try {
          recommender.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          // Some browsers (or older versions) don't support smooth scroll options
          try { recommender.scrollIntoView(); } catch (_) { /* ignore */ }
        }
      }
    }

    /**
     * Build a product URL from a handle. Falls back to the collection page
     * if the handle is missing or invalid. Optionally appends UTM-style
     * attribution params from the current recommendation.
     */
    function buildProductUrl(handle, rec) {
      var safeHandle = handle && typeof handle === 'string' ? handle.trim() : '';
      if (!safeHandle || !/^[a-z0-9][a-z0-9-]*$/i.test(safeHandle)) {
        console.warn('[Vedic Recommender] Invalid product handle:', handle);
        return ETCHCRAFT_BASE + '/collections/stone-series';
      }
      var base = ETCHCRAFT_BASE + '/products/' + safeHandle;
      if (!rec) return base;
      // UTM parameters — Shopify analytics and GA4 both attribute purchases
      // by these. Filter `utm_source=vedic-recommender` in your Shopify
      // Sales-by-referrer report to see how many orders came from this tool.
      // The `graha`, `lagna`, `dasha` params are descriptive, not used for
      // attribution but useful for debugging "did this user really see X?"
      var params = new URLSearchParams({
        utm_source:   'vedic-recommender',
        utm_medium:   'on-site',
        utm_campaign: 'vedic-stones',
        utm_content:  rec.dominant || '',
        ref:          'vedic-recommender',  // legacy parameter, kept for compatibility
        graha:        rec.dominant || '',
        lagna:        (rec.chart && rec.chart.ascendant) || '',
        dasha:        (rec.chart && rec.chart.mahadashaLord) || ''
      });
      return base + '?' + params.toString();
    }

    /**
     * Open a product page in a new tab. Handles the cases where:
     *   - Popup blocker blocks window.open (returns null)
     *   - Browser security policy prevents new-tab opens
     *   - User long-presses on mobile (already opens normally)
     * Falls back to in-tab navigation if new-tab is blocked.
     */
    function openProductPage(url) {
      if (!url) return;
      try {
        var win = window.open(url, '_blank', 'noopener,noreferrer');
        if (win) return;
      } catch (e) {
        console.warn('[Vedic Recommender] window.open failed:', e);
      }
      // Fallback: navigate in same tab — better than failing silently
      window.location.href = url;
    }

    function goToBuy() {
      if (!currentRecommendation) {
        openProductPage(ETCHCRAFT_BASE + '/collections/stone-series');
        return;
      }
      var primary = currentRecommendation.graha.candidates[0];
      var url = buildProductUrl(primary && primary.handle, currentRecommendation);
      openProductPage(url);
    }

    function resetFlow() {
      els.resultStep.hidden = true;
      els.introStep.hidden = false;
      els.placeholder.hidden = false;
      els.resultDisplay.hidden = true;
      // Reset patri panel for next reading
      if (els.patriToggle) els.patriToggle.setAttribute('aria-expanded', 'false');
      if (els.patriContent) {
        els.patriContent.hidden = true;
        els.patriContent.classList.remove('vedic-rec__patri-content--open');
      }
      if (els.patriLoading) els.patriLoading.hidden = true;
      if (els.patriError)   els.patriError.hidden   = true;
      if (els.patriDataEl)  els.patriDataEl.hidden  = true;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }
})();
